

























import Vue from 'vue'
import store from '@/store'
import { mapGetters } from 'vuex'
import ScriptHelpersHistory from '@/components/ScriptHelpers/history/ScriptHelpersHistory.vue'
import { RecordingsActionTypes } from '@/store/modules/recordings/actions'
import { RecordingInfoType, TabListItem } from '@/components/DataTable/models'
import {
  RecordingItem,
  RecordingColumnItem,
  ReadableRecordingItem,
} from '@/models/scripts'
import iconChevronLeft from '@/assets/svg/rounded/chevron-left.svg?inline'
import Loader from '@/components/Common/Loader.vue'
import moment from 'moment'

interface Props {
  columns: RecordingColumnItem[]
}

interface Data {
  recordId: string
  activeTab: RecordingInfoType
  showLoader: boolean
}

interface Methods {
  changeSelectTab: (type: RecordingInfoType) => void
  getRecordInfo: () => void
  closeRecordingInfo: () => void
  isActiveTab: (type: RecordingInfoType) => boolean
}

interface Computed {
  record: RecordingItem
  tabs: TabListItem[]
  isShowRecordTab: boolean
  isShowHistoryTab: boolean
  readableRecord: ReadableRecordingItem
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ScriptHelpersHistory,
    iconChevronLeft,
    Loader,
  },
  props: {
    columns: {
      required: true,
    },
  },
  data() {
    return {
      recordId: '',
      activeTab: RecordingInfoType.Record,
      showLoader: true,
    }
  },
  methods: {
    changeSelectTab(type) {
      this.activeTab = type
    },
    async getRecordInfo() {
      this.showLoader = true
      if (this.recordId) {
        await store.dispatch(RecordingsActionTypes.LoadHistory, this.recordId)
        const expand = this.columns.map(elem => elem.key).join()
        await store.dispatch(RecordingsActionTypes.LoadOnce, {
          id: this.recordId,
          expand,
        })
      }
      this.showLoader = false
    },
    isActiveTab(type) {
      return this.activeTab === type
    },
    closeRecordingInfo() {
      const query = Object.assign({}, this.$route.query)
      delete query.record
      this.$router.replace({ query })
      this.recordId = ''
    },
  },
  computed: {
    ...mapGetters({
      record: 'getRecordingItem',
    }),
    tabs() {
      const list = Object.values(RecordingInfoType)
      return list.map(elem => {
        return {
          type: elem,
          title: this.$tc('records.' + elem),
          isActive: this.activeTab === elem,
        }
      })
    },
    isShowRecordTab() {
      return this.activeTab === RecordingInfoType.Record
    },
    isShowHistoryTab() {
      return this.activeTab === RecordingInfoType.Chronology
    },
    readableRecord() {
      const target = this.$tc(`records.targetValue.${this.record.target}`)
      const started = moment
        .utc(this.record.started * 1000)
        .local()
        .format('DD.MM.YYYY HH:mm:ss')
      const finished = moment
        .utc(this.record.finished * 1000)
        .local()
        .format('DD.MM.YYYY HH:mm:ss')
      const duration = moment
        .utc(Number(this.record.duration) * 1000)
        .local()
        .format('HH:mm:ss')
      const finishType = this.$tc(
        `records.finishType.${this.record.finish_type}`,
      )
      const newRecord = Object.assign(
        {},
        // prettier-ignore
        { ...this.record, target, started, finished, duration, finish_type: finishType}, // eslint-disable-line @typescript-eslint/camelcase
      )
      delete newRecord.instance_id
      delete newRecord.user_id
      return newRecord
    },
  },
  watch: {
    '$route.query.record'(id) {
      if (id) {
        this.recordId = id
        this.getRecordInfo()
      } else {
        this.closeRecordingInfo()
      }
    },
  },
  created() {
    if (this.$route.query.record && this.$route.query.record.length) {
      this.recordId = this.$route.query.record as string
    }
    this.getRecordInfo()
  },
})
